module.exports = __webpack_public_path__ + "img/catalogBtn.42c4e51d.png";